import { Entity } from './entity';

export class Category extends Entity {
    public id: number
    public name: string
    public code: string
    public taxPayerType: string
    public additionalFields: []
  }  